import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
export default class BlogCategories extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "blogCategories", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.blogCategories = app.forum.attribute('blogTags');
  }
  view() {
    return m("div", {
      className: "BlogCategories BlogSideWidget"
    }, m("h3", null, app.translator.trans('fof-blog.forum.categories')), this.blogCategories && this.blogCategories.map(tagId => {
      const tag = app.store.getById('tags', tagId);
      if (!tag) return null;
      const tags = [];
      let showSubTags = this.blogCategories.length === 1 || tag.slug() === m.route.param('slug');

      // Add tags
      app.store.all('tags').forEach(_tag => {
        if (_tag.isChild() && _tag.parent() === tag) {
          if (_tag.slug() === m.route.param('slug')) {
            showSubTags = true;
          }
          tags.push(this.categoryItem(_tag));
        }
      });
      return showSubTags ? [this.categoryItem(tag), ...tags] : this.categoryItem(tag);
    }));
  }

  // Category item
  categoryItem(tag) {
    var _tag$color, _tag$icon;
    return m(Link, {
      href: app.route('blogCategory', {
        slug: tag.slug()
      }),
      className: "BlogSideWidget-item BlogSideWidget-item-".concat(tag.id(), " ").concat(tag.isChild() && app.forum.attribute('blogCategoryHierarchy') ? 'BlogSideWidget-item-child' : '')
    }, m("span", {
      className: !tag.icon() ? 'BlogSideWidget-item-colored' : '',
      style: {
        backgroundColor: !tag.icon() ? (_tag$color = tag.color()) != null ? _tag$color : undefined : undefined
      }
    }, m("i", {
      className: (_tag$icon = tag.icon()) != null ? _tag$icon : undefined
    })), tag.name());
  }
}
flarum.reg.add('fof-blog', 'forum/components/BlogCategories', BlogCategories);